import type { Dayjs } from 'dayjs';

export const isMoreThanOneDay = (start?: Dayjs | null, end?: Dayjs | null) => {
  if (!start || !end) return false;
  return !start.isSame(end, 'day') && start.isBefore(end, 'day');
};

export const eachDayOfInterval = (start: Dayjs, end: Dayjs) => {
  if (!start || !end) return [];
  const dates: string[] = [];
  let current = start;
  while (current.isBefore(end) || current.isSame(end, 'day')) {
    dates.push(current.format('YYYY-MM-DD'));
    current = current.add(1, 'day');
  }
  return dates;
};

export const compareAsc = (a: Dayjs, b: Dayjs) => {
  if (a.isBefore(b)) return -1;
  if (a.isAfter(b)) return 1;
  return 0;
};
